<template>
    <div v-if="isActive" class="modal" :class="{ 'is-active': isActive }">
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-content">
            <div class="box">
                <article class="media">
                    <div class="media-content" style="width: 100%;">
                        <div class="content">
                            <h3 class="title has-text-primary has-text-centered" >Enquire Now</h3>
                            <div class="theme-table-container table-container center-column">
                                <table class="auction-table theme-table table is-striped is-narrow is-hoverable is-scrollable is-fullwidth"
                                       id="enquiry-table">
                                    <thead>
                                    <tr class="top-header" id="resultTable">
                                        <th>Photo</th>
                                        <th>Lot No</th>
                                        <th>Date</th>
                                        <th>Model</th>
                                        <th>Grade</th>
                                        <th>Price</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td class="picture-td" data-label="photo">
                                            <div class="image is-64x64">
                                                <img :src="getCarObj.images + '&w=320'" @error="imgUrlAlt($event)">
                                            </div>
                                        </td>
                                        <td>{{ getCarObj.lot_num }}</td>
                                        <td>{{ getCarObj.auct_date }}</td>
                                        <td>{{ getCarObj.manuf_name }} {{ getCarObj.model_name }}</td>
                                        <td>{{ getCarObj.grade }}</td>
                                        <td>{{ getCarObj.price_start | formatNumber }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-if="getCounterOffer" class="what-info">Do you want to pay lesser for this car? let us know how much!</div>
                            <div class="card" id="enquiry-form">
                                <header class="card-header">
                                    <div class="card-header-title">
                                        Free Quote / Inquiry
                                    </div>
                                    <div class="card-header-icon" aria-label="more options">
              <span class="icon has-text-danger">
                <i class="fas fa-yen" aria-hidden="true"></i>
              </span>
                                    </div>
                                </header>
                                <div class="card-content">
                                    <div v-if="alertMessage" class="has-text-success">{{ alertMessage }}</div>
                                    <div class="field is-horizontal">

                                        <div class="field-label is-normal">
                                            <label>Full Name</label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <p class="control is-expanded">
                                                    <input v-model="full_name" class="input" type="text" placeholder="Full Name" readonly>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="field is-horizontal">
                                        <div class="field-label is-normal">
                                            <label>Email</label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <p class="control is-expanded ">
                                                    <input v-model="email" class="input" type="email" placeholder="Email" readonly>

                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="field is-horizontal">
                                        <div class="field-label is-normal">
                                            <label>Country</label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <div class="select is-fullwidth">
                                                    <select v-model="country">
                                                        <option value="">Select Country</option>
                                                        <option v-for="country in countries">{{ country.name }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="errorMessage" class="has-text-danger">{{ errorMessage[0] }}</div>
                                    <div class="field is-horizontal">
                                        <div class="field-label is-normal">
                                            <label>Phone<span class="has-text-danger">*</span></label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <p class="control is-expanded ">
                                                    <input required v-model="phone" class="input" type="number"
                                                           placeholder="Phone Number">

                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="getCounterOffer" class="field is-horizontal">
                                        <div class="field-label is-normal">
                                            <label>Counter-offer</label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <p class="control is-expanded ">
                                                    <input v-model="counter_offer" class="input" type="number"
                                                           placeholder="Counter-offer">

                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="field">
                                        <button class="button is-fullwidth is-danger enquiry" :class="{ 'is-loading' : isLoading }" @click="sendEnquiry">Enquiry</button>
                                    </div>
                                </div>
                            </div>
                            <div class="has-text-centered">
                                <a class="button" @click="closeModal">close</a>
                            </div>
                        </div>
                        </div>
                </article>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        props: ['lot', 'user'],
        data() {
            return {
                comment: {
                    body: '',
                },
                full_name: this.user.user.name,
                email: this.user.user.email,
                country: this.user.user_detail.country,
                phone: this.user.user_detail.phone,
                counter_offer: '',
                countries: [],
            }
        },
        computed: {
            isActive() {
                return this.$store.getters.getStockCarAlertModalStatus
            },
            alertMessage() {
                return this.$store.getters.getStockCarAlertMessage
            },
            errorMessage() {
                return this.$store.getters.getStockCarErrorMessage
            },
            isResponse() {
                return this.$store.getters.isResponse
            },
            getCarObj() {
                return this.$store.getters.getStockCarObj.lot
            },
            getUser() {
                return this.$store.getters.getStockCarObj.user
            },
            getCounterOffer() {
                return this.$store.getters.getStockCarObj.counterOffer
            },
            isLoading() {
                return this.$store.getters.getSearchResultsLoadingStatusStock
            }
        },
        methods: {
            closeModal() {
                this.$store.dispatch('setStockCarAlertDetails', {
                    stockCarAlertModalStatus: false, stockCarAlertMessage: null, carObj: null, isResponse: false
                })
            },
            sendEnquiry() {
                //this.alertMessage = null;
                //this.errorMessage = null;
                this.$store.dispatch('sendEnquiry', {carObj: this.getCarObj, name: this.full_name, email: this.email, country: this.country, phone: this.phone, counter_offer: this.counter_offer})
            },
            imgUrlAlt(event){
                event.target.src = '/static/images/hero-4.jpeg'
            }
        },
        created() {
            axios.get('https://restcountries.com/v3.1/all?fields=name')
                .then((response) => {
                    this.countries = response.data
                })
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/StockCars/EnquiryModal.vue